window.addEventListener('load', function () {
  // 1. Check if Splide is actually loaded to prevent errors
  if (typeof Splide === 'undefined') {
    console.error('Splide library is not defined. Please check your script loading order.');
    return;
  }

  // 2. Define the init function inside the load scope
  function initSplide(selector, options) {
    const sliders = document.querySelectorAll(selector);
    sliders.forEach(slider => {
        new Splide(slider, options).mount();
    });
  }

  // 3. Define the setup function
  function splider() {
    initSplide('.slide-con', {
      type: 'loop',
      perPage: 3,
      perMove: 1,
      gap: 24,
      pagination: false,
      autoplay: true,
      padding: '5rem',
      breakpoints: {
        1024: {
          perPage: 3,
          perMove: 1,
          rewind: true,
          padding: '4rem',
          focus: 'center',
          autoplay: true,
          gap: 20,
        },
        767: {
          autoplay: true,
          perPage: 2,
          perMove: 1,
          rewind: true,
          padding: '4rem',
          focus: 'center',
          gap: 20,
        },
        500: {
          autoplay: true,
          perPage: 2,
          perMove: 1,
          rewind: true,
          padding: '4rem',
          focus: 'center',
          gap: 14,
          arrows: false,
        },
      }
    });
  }

  // 4. Execute immediately since we are already inside the 'load' event
  splider();

});